// extracted by mini-css-extract-plugin
export var actionButton = "_bx-1";
export var actionButtons = "_bx-2";
export var actions = "_bx-0";
export var aiUnread = "_bx-10";
export var alignCenter = "_bx-h";
export var backWrapper = "_bx-3";
export var cellContainer = "_bx-4";
export var checkboxContainer = "_bx-5";
export var contentContainer = "_bx-6";
export var contentHeader = "_bx-8";
export var conversationsTableWrapper = "_bx-s";
export var draftReplyBadgeContainer = "_bx-m";
export var dropdownItem = "_bx-b";
export var dropdownItemsContainer = "_bx-a";
export var dropdownTitle = "_bx-c";
export var errorIcon = "_bx-7";
export var filter = "_bx-d";
export var gray = "_bx-i";
export var headerActionButtons = "_bx-e";
export var headerCheckboxContainer = "_bx-f";
export var icon = "_bx-j";
export var menuContainer = "_bx-k";
export var noMoreTicketsIcon = "_bx-12";
export var noMoreTicketsSubText = "_bx-13";
export var oneLine = "_bx-l";
export var optionsButton = "_bx-n";
export var plus = "_bx-o";
export var portalButtonsWrapper = "_bx-g";
export var red = "_bx-p";
export var scrolledTop = "_bx-9";
export var search = "_bx-q";
export var selectedConversationsCount = "_bx-r";
export var spinner = "_bx-t";
export var strong = "_bx-u";
export var summaryCell = "_bx-v";
export var tableContainer = "_bx-11";
export var tagContainer = "_bx-w";
export var threeDots = "_bx-x";
export var twoLines = "_bx-y";
export var unread = "_bx-z";